










































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'
import DatePickerComponent from '@/components/DatePickerComponent.vue'

@Component({
  components: {
    DatePickerComponent,
  },
})
export default class SelectMonthComponent extends Vue {
  @PropSync("dateType", { type: Number, default: 0, required: true })
  syncDateType!: number

  @Prop({ default: false })
  mandatory!: boolean

  @Prop({ default: false })
  viewOption!: boolean

  @PropSync("startOn", { type: String, default: "", required: true })
  syncStartOn!: string

  @PropSync("endOn", { type: String, default: "", required: true })
  syncEndOn!: string

  /** カレンダーの表示制御 */
  startOnCalender = false
  endOnCalender = false

  /* カレンダー入力の制御 */
  required = false
  disabled = true
  rules = ""

  /** 期間選択パターンリスト */
  selectList = [
    {value: 1, name: " 1"},
    {value: 2, name: " 2"},
    {value: 3, name: " 3"},
    {value: 4, name: " 4"},
    {value: 5, name: " 5"},
    {value: 6, name: " 6"},
    {value: 7, name: " 7"},
    {value: 8, name: " 8"},
    {value: 9, name: " 9"},
    {value: 10, name: "10"},
    {value: 11, name: "11"},
    {value: 12, name: "12"},
    {value: 99, name: "期間指定"},
  ]
  /** 追加オプション期間選択パターンリスト */
  selectOptionList = [
    {value: 0, name: "今日"},
    {value: -1, name: "今週"},
  ]

  mounted() {
    this.syncDateType = this.syncDateType === 0 ? this.thisMonth : this.syncDateType
    this.onChangeDateType()
  }

  /**
   * 期間指定が選択されているか？
   */
  private get isFreeInput() {
    return this.syncDateType === 99
  }

  /**
   * 今月を取得
   */
  private get thisMonth() {
    const now = new Date()
    now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
    now.setUTCDate(now.getUTCDate() - 5)
    return now.getUTCMonth() + 1
  }

  @Watch("dateType")
  onChangeDateType() {
    /* 現在日時を日本時間にずらす */
    const now = new Date()
    now.setTime(now.getTime() + 1000 * 60 * 60 * 9)

    const startOn = new Date(now.getTime())
    const endOn = new Date(now.getTime())
    const year = this.thisMonth < this.syncDateType ? startOn.getUTCFullYear() - 1 : startOn.getUTCFullYear()

    if (1 <= this.syncDateType && this.syncDateType <= 12) {
      /* 月 */
      startOn.setUTCFullYear(year, this.syncDateType - 1, 1)
      endOn.setUTCFullYear(year, this.syncDateType, 1)
      endOn.setUTCDate(0)
    } else if (this.syncDateType === -1) {
      /* 今週 */
      startOn.setUTCDate(startOn.getUTCDate() - startOn.getUTCDay())
      endOn.setUTCDate(endOn.getUTCDate() - endOn.getUTCDay() + 6)
    }

    if (this.syncDateType === undefined) {
      /* 未選択 */
      this.syncStartOn = ""
      this.syncEndOn = ""
      this.required = false
      this.rules = ""
    } else if (this.isFreeInput) {
      /* 期間指定 */
      this.required = true
      this.rules = "required"
    } else {
      /* 期間を選択値に変更 */
      this.syncStartOn = startOn.toISOString().substr(0, 10)
      this.syncEndOn = endOn.toISOString().substr(0, 10)
      this.required = false
      this.rules = ""
    }
    this.disabled = !this.required
  }
}
